import { defineMessages } from 'react-intl';

const messages = defineMessages({
  create_account: {
    defaultMessage: 'Create an Account',
  },
  registerWithWiQMsg: {
    defaultMessage: 'Create a single wi-Q account and use it to order from any wi-Q powered venue worldwide.',
  },
  registrationError: {
    defaultMessage: 'Registration Error!',
  },
  name: {
    defaultMessage: 'Name',
  },
  email: {
    defaultMessage: 'Email',
  },
  password: {
    defaultMessage: 'Password',
  },
  confirmPassword: {
    defaultMessage: 'Confirm Password',
  },
  register: {
    defaultMessage: 'Register',
  },
  forgot_password: {
    defaultMessage: 'Forgot password?',
  },
  passwordsDontMatch: {
    defaultMessage: "The passwords you typed didn't match.",
  },
  login: {
    defaultMessage: 'Login',
  },
  'Unable to register.': {
    defaultMessage: 'Unable to complete sign up, perhaps an account already exists, please try to login.',
  },
});

export default messages;
